<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()">
            Adicionar Meta
        </b-button>
        <meta-form
            operacaoProp="I"
            :acao="acao"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></meta-form>
    </div>
</template>

<script>
import MetaForm from './MetaForm'

export default {
    components: {
        MetaForm
    },

    props: {
        acao: Object,
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            acao: {
                pleitoId:0,
                nomeAcao: null,
                dataInicio: null,
                dataFim: null,
                vcCodUnidade:null,
            },
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(meta){
            this.$store.dispatch('addRequest')
            let metaDto = {
                acaoId: this.acao.acaoId,
                tipoInstrumento: meta.codCategoria,
                quantidade: meta.quantidade,
                quantidadeHorasTotais: meta.quantidadeHorasTotais,
                pequenosNegociosInscritos: meta.pequenosNegociosInscritos,
                numeroPessoasFisicas: meta.numeroPessoasFisicas,
            }
            this.dataServicos.inserirMeta(metaDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Meta inserida com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
